import { Pagination as AntdPagination } from 'antd';
import { createGuardedComponent } from '../../provider/create-guarded-component';

export type { PaginationProps } from 'antd';

export const Pagination = createGuardedComponent(AntdPagination) as typeof AntdPagination;
